import { ConfirmDialogProvider as BaseConfirmDialogProvider } from '@omit/react-confirm-dialog'

export const ConfirmDialogProvider = ({
  children,
}: {
  children: React.ReactNode
}) => {
  return <BaseConfirmDialogProvider>{children}</BaseConfirmDialogProvider>
}

export default ConfirmDialogProvider
